/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/api-integration.js":
/*!******************************************!*\
  !*** ./js/components/api-integration.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   submitForm: () => (/* binding */ submitForm)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");



// Token constants
var TOKEN_COOKIE_NAME = 'adapthealth_client_token';
var TOKEN_EXPIRY_COOKIE_NAME = 'adapthealth_client_token_expiry';
var TOKEN_VALIDITY_HOURS = 23;
var TOKEN_VALIDITY_MS = TOKEN_VALIDITY_HOURS * 60 * 60 * 1000;

// Environment-specific auth credentials — reads staging flag from window directly
var getAuthCredentials = () => {
  var staging = window.shopifyVariables.isStaging;
  return {
    baseURL: staging ? 'https://nonprodapi.adapthealth.com/use1/qa/exp/auth/v1/' : 'https://prod.adapthealth.com/auth/v1/',
    clientId: staging ? 'c7530cc8e3484bfa9be53a318d9ac2d6' : '9824d5e2e0aa44fb9b9ee8a10bf371a7',
    clientSecret: staging ? 'e533DC22a55641EaABAF0C0dDa604b36' : '94D6da29241E4E66b58dA71962fb6c5D'
  };
};

// Form API client — base URL varies by environment; callers pass only the route path
var formClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
  baseURL: window.shopifyVariables.isStaging ? 'https://nonprodapi.adapthealth.com/use1/qa/exp/adapthealth/v1/api/forms' : 'https://prod.adapthealth.com/adapthealth/v1/api/forms',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Cookie utilities
var setCookie = (name, value, hours) => {
  var expires = new Date();
  expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
  document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(expires.toUTCString(), ";path=/;SameSite=Lax");
};
var getCookie = name => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
};
var deleteCookie = name => {
  document.cookie = "".concat(name, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;");
};

// Token cache
var getCachedToken = () => {
  var token = getCookie(TOKEN_COOKIE_NAME);
  var expiry = getCookie(TOKEN_EXPIRY_COOKIE_NAME);
  if (!token || !expiry) return null;
  var now = new Date().getTime();
  var expiryTime = parseInt(expiry, 10);
  if (now >= expiryTime) {
    deleteCookie(TOKEN_COOKIE_NAME);
    deleteCookie(TOKEN_EXPIRY_COOKIE_NAME);
    return null;
  }
  return token;
};
var cacheToken = token => {
  var expiryTime = new Date().getTime() + TOKEN_VALIDITY_MS;
  setCookie(TOKEN_COOKIE_NAME, token, TOKEN_VALIDITY_HOURS);
  setCookie(TOKEN_EXPIRY_COOKIE_NAME, expiryTime.toString(), TOKEN_VALIDITY_HOURS);
};

// Token generation
var tokenGenerationPromise = null;
var generateClientToken = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    if (tokenGenerationPromise) return tokenGenerationPromise;
    tokenGenerationPromise = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var _response$data;
        var credentials = getAuthCredentials();
        var authClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
          baseURL: credentials.baseURL,
          headers: {
            'Content-Type': 'text/html'
          }
        });
        var response = yield authClient.post('client/token', null, {
          headers: {
            client_id: credentials.clientId,
            client_secret: credentials.clientSecret,
            grant_type: 'CLIENT_CREDENTIALS',
            Accept: 'application/json'
          }
        });
        var token = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.access_token;
        if (!token) throw new Error('No access token received from token endpoint');
        return token;
      } catch (error) {
        console.error('Error generating client token:', error);
        throw new Error("Failed to generate client token: ".concat(error.message));
      } finally {
        tokenGenerationPromise = null;
      }
    })();
    return tokenGenerationPromise;
  });
  return function generateClientToken() {
    return _ref.apply(this, arguments);
  };
}();
var validateClientToken = /*#__PURE__*/function () {
  var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (token) {
    try {
      var _response$data2;
      var credentials = getAuthCredentials();
      var authClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
        baseURL: credentials.baseURL
      });
      var response = yield authClient.get('client/validate', {
        headers: {
          Authorization: "".concat(token),
          Accept: 'application/json'
        }
      });
      return ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.client_id) === credentials.clientId;
    } catch (error) {
      console.error('Error validating client token:', error);
      return false;
    }
  });
  return function validateClientToken(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var getOrRefreshClientToken = /*#__PURE__*/function () {
  var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var token = getCachedToken();
    if (token) {
      var _isValid = yield validateClientToken(token);
      if (_isValid) return token;
      deleteCookie(TOKEN_COOKIE_NAME);
      deleteCookie(TOKEN_EXPIRY_COOKIE_NAME);
      token = null;
    }
    token = yield generateClientToken();
    var isValid = yield validateClientToken(token);
    if (!isValid) console.warn('New token validation failed, but caching anyway');
    cacheToken(token);
    return token;
  });
  return function getOrRefreshClientToken() {
    return _ref4.apply(this, arguments);
  };
}();

// Main form submission function — accepts a route path (e.g. '/diabetes/enrollment'),
// not a full URL. The base URL is determined by the environment via formClient.
var submitForm = /*#__PURE__*/function () {
  var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (path) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!path) {
      return {
        ok: false,
        status: 0,
        data: null,
        text: 'Form endpoint is missing'
      };
    }
    try {
      var token = yield getOrRefreshClientToken();
      var response = yield formClient.post(path, data, {
        headers: {
          Accept: 'application/json',
          Authorization: token
        }
      });
      var text = response.data ? JSON.stringify(response.data) : '';
      return {
        ok: true,
        status: response.status,
        data: response.data,
        text
      };
    } catch (error) {
      var _error$response, _error$response2;
      var status = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) || 0;
      var responseData = (error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) || null;
      var _text = responseData ? JSON.stringify(responseData) : error.message || 'Unknown error';
      return {
        ok: false,
        status,
        data: responseData,
        text: _text
      };
    }
  });
  return function submitForm(_x2) {
    return _ref5.apply(this, arguments);
  };
}();


/***/ }),

/***/ "./js/components/cart-functions.js":
/*!*****************************************!*\
  !*** ./js/components/cart-functions.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   removeCartJwtAttribute: () => (/* binding */ removeCartJwtAttribute),
/* harmony export */   storeCartJwtAttribute: () => (/* binding */ storeCartJwtAttribute),
/* harmony export */   updateStagingAttributes: () => (/* binding */ updateStagingAttributes)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");


var shopifyCartClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
  baseURL: "/",
  headers: {
    "Content-Type": "application/json"
  }
});
var updateAttributes = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (attributes) {
    var res = yield shopifyCartClient.post("cart/update.js", {
      attributes
    });
    return res.data;
  });
  return function updateAttributes(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getAttributes = () => {
  var isStaging = window.shopifyVariables.isStaging;
  var attributes = {
    "_isStaging": Boolean(isStaging)
  };
  return attributes;
};
var storeCartJwtAttribute = /*#__PURE__*/function () {
  var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (token) {
    var attributes = {
      "JWT Token": token
    };
    var res = yield updateAttributes(attributes);
    return res.data;
  });
  return function storeCartJwtAttribute(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var removeCartJwtAttribute = /*#__PURE__*/function () {
  var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var attributes = {
      "JWT Token": null
    };
    var res = yield updateAttributes(attributes);
    return res.data;
  });
  return function removeCartJwtAttribute() {
    return _ref3.apply(this, arguments);
  };
}();
var updateStagingAttributes = /*#__PURE__*/function () {
  var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var attributes = getAttributes();
    var res = yield updateAttributes(attributes);
    return res.data;
  });
  return function updateStagingAttributes() {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./js/sections/form.js":
/*!*****************************!*\
  !*** ./js/sections/form.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/react-wrapper */ "./js/components/react-wrapper.js");
/* harmony import */ var ReactComponents_cart_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ReactComponents/cart-form */ "./js/components/react/cart-form.js");
/* harmony import */ var _components_react_recovery_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/react/recovery-form */ "./js/components/react/recovery-form.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(ReactComponents_cart_form__WEBPACK_IMPORTED_MODULE_1__["default"], 'cart-form');
  (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(_components_react_recovery_form__WEBPACK_IMPORTED_MODULE_2__["default"], 'recovery-form');
});

/***/ }),

/***/ "./js/sections/section.js":
/*!********************************!*\
  !*** ./js/sections/section.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./form */ "./js/sections/form.js");
/* harmony import */ var _components_get_oauth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/get-oauth */ "./js/components/get-oauth.js");
/* harmony import */ var _components_cart_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/cart-functions */ "./js/components/cart-functions.js");
/* harmony import */ var _components_react_api_integration__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../components/react/api-integration */ "./js/components/react/api-integration.js");
/* harmony import */ var _components_api_integration__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../components/api-integration */ "./js/components/api-integration.js");






window.submitForm = _components_api_integration__WEBPACK_IMPORTED_MODULE_5__.submitForm;
function handleLoginBtn() {
  document.querySelectorAll("#login-btn").forEach(btn => {
    btn.addEventListener("click", /*#__PURE__*/function () {
      var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (ev) {
        var redirectUrl = window.location.href;
        var parsedUrl = new URL(window.location.href);
        var params = new URLSearchParams(parsedUrl.search);
        var checkoutUrl = params.get('checkout_url');
        var decodedCheckoutUrl = checkoutUrl ? decodeURIComponent(checkoutUrl) : "";
        if (decodedCheckoutUrl && decodedCheckoutUrl !== "null") {
          redirectUrl = decodedCheckoutUrl;
        }
        ev.preventDefault();
        var token = yield (0,_components_get_oauth__WEBPACK_IMPORTED_MODULE_2__.getToken)();
        if (token) {
          try {
            yield (0,_components_react_api_integration__WEBPACK_IMPORTED_MODULE_4__.loginToShopify)(redirectUrl, true);
          } catch (e) {
            console.error("Failed to store JWT in cart:", e);
          }
        }
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
}
function handleGuestLoginBtn() {
  document.querySelectorAll("#guest-login-btn").forEach(btn => {
    btn.addEventListener("click", /*#__PURE__*/function () {
      var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (ev) {
        var redirectUrl = "https://acho-diabetes.myshopify.com/checkout";
        var parsedUrl = new URL(window.location.href);
        var params = new URLSearchParams(parsedUrl.search);
        var checkoutUrl = params.get('checkout_url');
        var decodedCheckoutUrl = decodeURIComponent(checkoutUrl);
        if (decodedCheckoutUrl && decodedCheckoutUrl !== "null") {
          redirectUrl = decodedCheckoutUrl;
        }
        ev.preventDefault();
        try {
          yield (0,_components_cart_functions__WEBPACK_IMPORTED_MODULE_3__.removeCartJwtAttribute)();
          window.location.href = redirectUrl;
        } catch (e) {
          console.error("Failed to remove JWT from cart:", e);
        }
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  });
}
function handleLogoutBtn() {
  var logoutbtn = document.querySelector('[data-account-logout]');
  if (logoutbtn) {
    logoutbtn.addEventListener('click', () => {
      (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
        yield (0,_components_get_oauth__WEBPACK_IMPORTED_MODULE_2__.logout)();
      })();
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  (0,_form__WEBPACK_IMPORTED_MODULE_1__["default"])();
  handleLoginBtn();
  handleGuestLoginBtn();
  handleLogoutBtn();
  (0,_components_cart_functions__WEBPACK_IMPORTED_MODULE_3__.updateStagingAttributes)();
});
document.addEventListener('cart:updated', event => {
  debugger;
  (0,_form__WEBPACK_IMPORTED_MODULE_1__["default"])();
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; (typeof current == 'object' || typeof current == 'function') && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"section": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/section.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;